import React from "react";
import { NewDynamicTab } from "../../../components/Page";
import { JvvnlOverviewMetric } from "../../../config/DefaultDates";
import { JvvnlTitle, TabSwitcher } from "../Jvnnl_Dashboard";
import JvvnlGlobalSearch from "../../../components/Search/Jvvnl/GlobalSearch";
import JvvnlMetric from "./JvvnlMetric";

const Metric = () => {
  return (
    <NewDynamicTab
      headerPrefixComponent={<TabSwitcher />}
      rightPrefixComponent={<JvvnlGlobalSearch />}
      defaultDates={JvvnlOverviewMetric}
      header="Net Load & DRE Flow"
      showTabs={false}
      middleComponent={<JvvnlTitle />}
      tabs={{
        Metric: <JvvnlMetric />,
      }}
    />
  );
};

export default Metric;
